import { render, staticRenderFns } from "./BookingListItem.vue?vue&type=template&id=0610d77a&scoped=true"
import script from "./BookingListItem.vue?vue&type=script&lang=js"
export * from "./BookingListItem.vue?vue&type=script&lang=js"
import style0 from "./BookingListItem.vue?vue&type=style&index=0&id=0610d77a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0610d77a",
  null
  
)

export default component.exports